/** Customer blocklist. */
import { endpoints } from '@/config/env';
import type { BlocklistEntry, BlocklistStats } from '@/types';
import { request } from './client';

export function fetchBlocklist(
  range: { from?: string; to?: string } = {},
  signal?: AbortSignal,
): Promise<BlocklistEntry[] | null> {
  return request<BlocklistEntry[] | null>(endpoints.blocklist(range), { signal });
}

export function fetchBlocklistStats(
  range: { from?: string; to?: string } = {},
  signal?: AbortSignal,
): Promise<BlocklistStats | null> {
  return request<BlocklistStats | null>(endpoints.blocklistStats(range), { signal });
}

export function blockCustomer(
  input: { customerEmail?: string; customerPhone?: string; reason?: string; customerName?: string },
): Promise<BlocklistEntry | null> {
  return request<BlocklistEntry | null>(endpoints.blocklist(), {
    method: 'POST',
    body: input,
  });
}

export function unblockCustomer(blockId: string): Promise<null> {
  return request<null>(endpoints.blocklistEntry(blockId), { method: 'DELETE' });
}
